/**
 * @generated SignedSource<<c752f2e7aaa0ff936b304a21db3913dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightListPrice_flight$data = {
  readonly lastPriceLive: number;
  readonly priceLive: number;
  readonly " $fragmentType": "FlightListPrice_flight";
};
export type FlightListPrice_flight$key = {
  readonly " $data"?: FlightListPrice_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListPrice_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListPrice_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceLive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPriceLive",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "dbfe15ab866b4db2998769db2571a97d";

export default node;
